<div class="dsr-main-container">
    <owc-card oneCard class="dsr-one-card">
        <div style="display: flex; flex-direction: column;">
            <h4 class="mat-title" style="margin: 0px;">Enable Daily Summary Report</h4>
            <owc-switch [(ngModel)]="isDailySummaryEnabled" style="font-size: 16px;" (ngModelChange)="toggleEnable($event)">
                Enabled
            </owc-switch>
        </div>
        <div *ngIf="isDailySummaryEnabled">
            <div class="dsr-content-section">
                <h4 style="margin:5px 0px; font-weight: 400;">Include in report:</h4>
                <div class="dsr-checkbox-group">
                    <owc-checkbox *ngFor ="let options of reportContent" [checked]="selected.has(options)" class="dsr-individual-checkbox" (change)="contentSelection(options, $event)">{{options}}</owc-checkbox>
                    <owc-checkbox class="dsr-individual-checkbox" [checked]="isAllSelected()" (change)="contentAllSelection($event)">All</owc-checkbox>
                </div>
                <div class="dsr-send-report-section">
                    <h4 style="margin:5px 0px; font-weight: 400;">Send report to:</h4>
                    <owc-input class="dsr-sendto-input" [formControl]="sendToControl" (blur)="onEmailBlur()"></owc-input>
                    <div *ngIf="emailRequired || invalidEmail" class="error">
                        <owc-assistive-text class="assText" style ="margin-left:10px" *ngIf="emailRequired">Email is required.</owc-assistive-text>
                        <owc-assistive-text class="assText" style ="margin-left:10px" *ngIf="invalidEmail">Please enter a valid email address.</owc-assistive-text>
                    </div>
                </div>
            </div>
        </div>
    </owc-card>
</div>
